export default function Hero() {
  return (
    <section id="top" className="pt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="relative overflow-hidden rounded-lg">
            <img
              src="https://images.unsplash.com/photo-1518770660439-4636190af475?ixid=M3w0MzUxNjF8MHwxfHNlYXJjaHw0fHx0ZWNobm9sb2d5fGVufDB8fHx8MTc1MjQ0MDg5NHww&ixlib=rb-4.1.0&orientation=landscape&fit=crop&crop=entropy%2Cfaces&auto=format%2Ccompress&w=1280"
              alt="GPU computing technology"
              className="w-full h-auto object-cover rounded-lg"
            />
          </div>

          <div className="flex flex-col justify-center">
            <h1 className="font-heading font-bold text-3xl md:text-5xl leading-tight text-foreground-950">
              High-Performance and Flexible AI Compute
            </h1>
            <p className="mt-6 text-foreground-600 leading-relaxed">
              Abstract Data provides top-tier compute with Reserved GPUaaS,
              unlocking your innovation potential and driving high-speed growth
              for enterprises and research projects.
            </p>
            <a
              href="#services"
              className="mt-8 inline-flex self-start px-7 py-3 text-base font-semibold whitespace-nowrap rounded-md bg-foreground-950 text-background-50 hover:bg-foreground-800 cursor-pointer transition-colors"
            >
              Learn more
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              AI Compute
            </h2>
            <p className="mt-1 text-foreground-500">Reserved GPUaaS</p>
          </div>
          <div className="relative overflow-hidden rounded-lg">
            <img
              src="https://images.unsplash.com/photo-1523961131990-5ea7c61b2107?ixid=M3w0MzUxNjF8MHwxfHNlYXJjaHwxM3x8ZGF0YSUyMGNlbnRlcnxlbnwwfHx8fDE3NTIyNTc4NjR8MA&ixlib=rb-4.1.0&orientation=landscape&fit=crop&crop=entropy%2Cfaces&auto=format%2Ccompress&w=1280"
              alt="Data center servers"
              className="w-full h-auto object-cover rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}